import React from "react"
import { Container } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <div className="text-sm-end d-none d-sm-block">
          <span className="mx-3 badge  bg-secondary ">

          </span>
            {new Date().getFullYear()} © tccontrol grupoDa2

          </div>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
